import { Component, ViewChild } from '@angular/core';
import { ChatService } from '../../services/chat.service';
import { ChatMessage, Role } from '../../services/chat-message';
import { TemplateEditorService } from 'src/app/template-editor/services/template-editor.service';
import { BroadcasterService } from 'src/app/shared/services/broadcaster.service';
import { PresentationPreviewComponent } from 'src/app/presentations/components/presentation-preview/presentation-preview.component';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  standalone: false
})
export class ChatComponent {
  @ViewChild('templateEditorPreviewHolder') public templateEditorPreviewHolder: PresentationPreviewComponent;

  history: ChatMessage[] = [];
  newMessage: String = '';
  presentation: any = {};
  attributeData: any = null;

  constructor(
    private broadcaster: BroadcasterService,
    private chatService: ChatService,
    private templateEditorService: TemplateEditorService,
    private companyStateService: CompanyStateService) {

      const presentationId = '9b4aff1b-bbc3-4319-ab37-beac7fa9caa0';

      this.loadPresentation(presentationId);
    }

  loadPresentation(presentationId: string): void {

    this.templateEditorService.getPresentation(presentationId)
      .then(presentation => {
        this.presentation = presentation;
        this.attributeData = null;

        this.broadcaster.emit('risevision.aiservice.presentationChanged');
      });
  }

  send(): void {
    const message = this.newMessage.trim();

    this.newMessage = '';

    console.log('Sending message:', message);

    if (message) {
      const payload = {
        companyId: this.companyStateService.getSelectedCompanyId(),
        count: 5,
        templates: this.getRecommendedTemplates(),
        presentations: this.getPresentationsSearchResults(),
        attributeData: this.getAttributeData()
      };
      const cleanHistory = this.history
        .map(msg => {
          if (msg.role === 'assistant') {
            return { ...msg, content: '...' as any };
          }
          return msg;
        });

      this.newMessage = '';
      this.addUserMessage(message);

      this.chatService.sendMessage(message, cleanHistory, payload).subscribe({
        next: (response: any) => {
          this.addChatMessage('assistant', response);

          if (response.type === 'presentation_select') {
            this.loadPresentation(response.response);
          }
          else if (response.type === 'presentation_edit') {
            const attributeData = {
              ...this.templateEditorPreviewHolder.getAttributeData(),
              components: response.response
            };

            this.attributeData = attributeData;
            this.templateEditorPreviewHolder.postAttributeData(attributeData);
          }
          else if (response.type === 'template_create_from') {
            this.createPresentationFromTemplate(response.response);
          }
        },
        error: (err) => {
          console.error('Error sending message:', err);
          this.addErrorMessage('Error sending message. Please try again.');
        }
      });
    }
  }

  addUserMessage(message: string): void {
    this.addChatMessage('user', message);
  }

  addAssistantMessage(message: string): void {
    this.addChatMessage('assistant', { type: 'chat', response: message });
  }

  addErrorMessage(message: string): void {
    this.addChatMessage('error', { type: 'error', response: message});
  }

  addChatMessage(role: Role, message: any): void {
    this.history.push({
      role: role,
      content: message,
      timestamp: new Date()
    });
  }

  getRecommendedTemplates(): any[] {
    const results = this.history
      .filter(msg => msg.role === 'assistant' && msg.content.type === 'template_search')
      .map(msg => msg.content.response || []);

    return results.length > 0 ? results[results.length - 1] : [];
  }

  getPresentationsSearchResults(): any[] {
    const results = this.history
      .filter(msg => msg.role === 'assistant' && msg.content.type === 'presentation_search')
      .map(msg => msg.content.response || []);

    return results.length > 0 ? results[results.length - 1] : [];
  }

  getAttributeData(): any {
    return this.attributeData || this.templateEditorPreviewHolder.getAttributeData() || {};
  }

  createPresentationFromTemplate(template: any): void {
    this.templateEditorService.aiEditorActive = true;

    this.templateEditorService.addFromProduct({
      productCode: template.productCode,
      name: template.name + ' - ' + new Date().toISOString(),
    })
    .then(presentationId => {
      console.log('Template created with ID:', presentationId);

      this.attributeData = null;
      this.broadcaster.emit('risevision.aiservice.presentationChanged');
    })
    .catch((err) => {
      console.error('Error creating template:', err);
      this.addErrorMessage('Error creating template. Please try again.');
    })
    .finally(() => {
      this.templateEditorService.aiEditorActive = false;
    });
  }
}
